import type { AxiosRequestConfig, AxiosResponse } from 'axios';
import axios from 'axios';
import { rememberReturnPath } from './returnPath';

export const apiClient = axios.create();

// Interceptor to ensure to redirect the user to login page or expired trial page
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      rememberReturnPath(window.location.pathname + window.location.search + window.location.hash);
      window.location.href = `${window.location.protocol}//${window.location.host}`; // Redirect to root, which is login page
    }
    if (error.response?.status === 402) {
      window.location.href = `${window.location.protocol}//${window.location.host}/expired-trial`; // Redirect to expired trial page
    }
    return Promise.reject(error);
  },
);

export const get = async <T>(
  url: string,
  options?: AxiosRequestConfig,
): Promise<T> => {
  const response: AxiosResponse = await apiClient.get<T>(
    url,
    options || undefined,
  );
  return response.data;
};

export const post = async <T>(
  url: string,
  data?: any,
  options?: AxiosRequestConfig,
): Promise<T> => {
  const response: AxiosResponse = await apiClient.post<T>(
    url,
    data,
    options || undefined,
  );
  return response.data;
};

export const put = async <T>(
  url: string,
  data?: any,
  options?: AxiosRequestConfig,
): Promise<T> => {
  const response: AxiosResponse = await apiClient.put<T>(
    url,
    data,
    options || undefined,
  );
  return response.data;
};

export const patch = async <T>(
  url: string,
  data?: any,
  options?: AxiosRequestConfig,
): Promise<T> => {
  const response: AxiosResponse = await apiClient.patch<T>(
    url,
    data,
    options || undefined,
  );
  return response.data;
};

export const del = async <T>(
  url: string,
  options?: AxiosRequestConfig,
): Promise<T> => {
  const response: AxiosResponse = await apiClient.delete<T>(
    url,
    options || undefined,
  );
  return response.data;
};
